export default __webpack_public_path__ + "static/media/ComingSoon.ba1b1518.png";